import { CommissionRuleMethod, ICommission } from 'gen/ApiClient';
import { calculateCommissionX } from './calculateCommissionX';

export const calculateCommissionF = (item: ICommission): number => {
	return calculateCommissionX(item.totalValueExVatOfSale, item.totalValueExVatOfDevices, item.ruleMethod as CommissionRuleMethod, item.rulePercentage);
};
